import { useState } from "react";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { getPolicyDataTransferByToken, getUrl, removeUrl } from "../../service";

export const usePostSocialLogin = () => {
    const navigate = useNavigate();
    const [redirectPath] = useState(getUrl);
    const [isPolicyModalOpen, setIsPolicyModalOpen] = useState<boolean>(false);

    const goBackToBeforeLogin = () => {
        removeUrl();
        navigate(redirectPath ?? "/", { replace: true });
    };

    const finishLogin = async () => {
        try {
            const { data } = await getPolicyDataTransferByToken();
            if (!data.isPersonInfoPolicyAgree || !data.isServiceUseTermAgree) {
                setIsPolicyModalOpen(true);
                return;
            }
            goBackToBeforeLogin();
        } catch (error) {
            console.error("error", error);
            if ((error as AxiosError).response?.status === 401) return;
            goBackToBeforeLogin();
        }
    };

    return { redirectPath, isPolicyModalOpen, finishLogin, goBackToBeforeLogin };
};
